module.exports = __webpack_public_path__ + "static/media/BTECH_EXTC_2021-2025_Scheme_twice_modified.29d1b324.pdf";